import {
  createOpenAICompatible,
  type OpenAICompatibleProvider,
} from '@ai-sdk/openai-compatible';
import {
  withoutTrailingSlash,
} from '@ai-sdk/provider-utils';
import { DzmmChatModelId } from './dzmm-chat-settings';

export interface DzmmProviderSettings {
  apiKey?: string;
  baseURL?: string;
  headers?: Record<string, string>;
}

export type DzmmProvider = OpenAICompatibleProvider<DzmmChatModelId>;

export function createDzmm(
  options: DzmmProviderSettings = {},
): DzmmProvider {
  const baseURL = withoutTrailingSlash(
    options.baseURL ?? process.env.DZMM_BASE_URL ?? 'https://www.gpt4novel.com/api/xiaoshuoai/ext/v1'
  );

  const apiKey = options.apiKey ?? process.env.DZMM_API_KEY;

  if (!apiKey) {
    throw new Error('DZMM API key is required. Set DZMM_API_KEY environment variable or provide apiKey option.');
  }

  return createOpenAICompatible({
    name: 'dzmm',
    baseURL: baseURL as string,
    apiKey: apiKey as string,
    headers: options.headers,
  });
}

export const dzmm = createDzmm();